import React, { type ReactElement } from 'react';

import ProFocusOption from '../ProFocusOption';
import ClusterSection from './Section';
import { ClusterParams } from './interfaces';

const ClusterAccess = ({
  sectionData: { components, headline },
}: Omit<ClusterParams, 'clusterID' | 'dollarSavings' | 'proOfferCode'>): ReactElement => (
  <ClusterSection
    className="mt-48 border-0 border-b border-solid border-pro-gold px-28 pb-48 sm:mt-64 sm:px-0"
    headline={headline}
  >
    <div className="mt-8 flex flex-col sm:mx-auto sm:mt-32 sm:flex-row sm:flex-wrap sm:gap-x-40 sm:gap-y-48 md:mx-auto md:max-w-[848px] md:gap-x-64 lg:max-w-none lg:flex-nowrap">
      {components.map((component, index) => (
        <ProFocusOption
          key={`profocusoption-${index}`}
          buttonClassName="!text-description-lg"
          containerClassName="border-pro-gold !border-t sm:!border-t-0 odd:sm:w-[calc(50%_-_60px)] sm:w-[calc(50%_-_20px)] sm:[&:nth-child(3)]:!pl-0 sm:[&:nth-child(3)]:border-l-0 sm:[&:nth-child(3)]:ml-0 lg:w-[calc(33.3%_-_20px)] odd:lg:w-[calc(33.3%_-_60px)] lg:[&:nth-child(3)]:!pl-40 lg:[&:nth-child(3)]:border-l sm:!ml-0 sm:!pl-40 lg:!pl-40"
          description={component.description}
          descriptionClassName="!text-description-lg"
          index={index}
          isProSubscriberNotBot={false}
          secondaryTitle={component.secondaryTitle}
          slug=""
          title={component.title}
          titleClassName="text-headline-alt-sm *:inline sm:*:block"
        />
      ))}
    </div>
  </ClusterSection>
);

export default ClusterAccess;
